/**
 * SCROLL
 * Scroll-based behavioral enhancements.
 * - Smooth scroll to anchor links
 */

export function init() {

  // ---------------------------------------------------------
  // SMOOTH SCROLL TO ANCHORS
  // Intercepts clicks on anchor links and smooth-scrolls
  // to the target element instead of jumping.
  // ---------------------------------------------------------

  document.addEventListener('click', (e) => {
    const link = e.target.closest('a[href*="#"]');
    if (!link) return;

    let href = link.getAttribute('href');

    // Strip leading slash for same-page anchors
    if (href.startsWith('/')) {
      href = href.replace(/^\//, '');
    }

    // Only handle if the target element exists on this page
    const target = document.querySelector(href);
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth' });
    }
  });
}
